const getDataAttributeValue = (variation, testID) => {
  if (!testID) { return undefined; }
  return `btn-${variation}-${testID}`;
};
export default getDataAttributeValue;
